import React from 'react';
import Layout from '../components/layout';
import { graphql, Link } from 'gatsby';

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
  gridAutoRows: '1fr',
  gridGap: '0.8px',
}

export default ({ data }) => {
  return (
    <Layout>
      <div style={gridStyle}>
        {data.allMarkdownRemark.edges.map(({ node }) => {
          if (node.frontmatter.noContent) {
            return (
              <span key={node.id} style={{justifySelf: 'center'}} >
                <img
                  className={'titleImageNoContent'}
                  src={`/titles/${node.fields.slug.replace(/\//g, '')}.png`}
                  alt={node.fields.slug}
                />
              </span>
            );
          }
          return (
            <Link to={`/works${node.fields.slug}`} key={node.id} style={{justifySelf: 'center'}} >
              <img
                className={'titleImage'}
                src={`/titles/${node.fields.slug.replace(/\//g, '')}.png`}
                alt={node.fields.slug}
              />
            </Link>
          );
        })}
      </div>
    </Layout>
  );
};

export const query = graphql`
  query {
    allMarkdownRemark(sort: {fields: [frontmatter___albumNumber, frontmatter___truck], order: [DESC, ASC]}) {
      edges {
        node {
          id
          frontmatter {
            title
            year
            noContent
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;
